import { useMarkAllAnnouncementsAsRead } from '~/features/announcements/data.ts'

function MarkAllAsReadButton() {
  const markAllAsRead = useMarkAllAnnouncementsAsRead()

  return (
    <button
      type="button"
      className="btn btn--link header-announcements__mark-all-as-read-btn"
      onClick={async () => {
        markAllAsRead.execute()
      }}
    >
      Mark all as read
    </button>
  )
}

export default MarkAllAsReadButton
